import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import css from "./CalculatedResult.module.css";
import Paper from "@material-ui/core/Paper";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PlaceIcon from '@material-ui/icons/Place';
import TimelineIcon from '@material-ui/icons/Timeline';
import TimerIcon from '@material-ui/icons/Timer';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import NightsStayIcon from '@material-ui/icons/NightsStay';


export default function CalculatedResultList(props) {
  return (
    <>
      <div className={css.TableContainer}>
        <h4 className={css.Title}>Viaje</h4>
        <TableContainer component={Paper}>
          <Table className={css.Table} size="small" aria-label="viaje">
            <TableBody>
              <TableRow key="Viaje-origin">
                <TableCell className={css.tdtitle} align="left"><PlayArrowIcon fontSize="small"></PlayArrowIcon> <span>Origen</span></TableCell>
                <TableCell align="right">
                  {props.origin.calle} {props.origin.numero}
                </TableCell>
              </TableRow>
              <TableRow key="Viaje-destiny">
                <TableCell className={css.tdtitle} align="left"><PlaceIcon fontSize="small"></PlaceIcon> <span>Destino</span></TableCell>
                <TableCell align="right">
                  {props.destiny.calle} {props.destiny.numero}
                </TableCell>
              </TableRow>
              <TableRow key="Viaje-distance">
                <TableCell className={css.tdtitle} align="left"><TimelineIcon fontSize="small"></TimelineIcon> <span>Distancia</span></TableCell>
                <TableCell align="right">{props.price.Distancia.toString()}</TableCell>
              </TableRow>
              <TableRow key="Viaje-duration">
                <TableCell className={css.tdtitle} align="left"><TimerIcon fontSize="small"></TimerIcon> <span>Duración</span></TableCell>
                <TableCell align="right">{props.price.Duracion}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <div className={css.TableContainer}>
        <h4 className={css.Title}>Coste</h4>
        <TableContainer component={Paper}>
          <Table className={css.Table} size="small" aria-label="coste">
            <TableBody>
              <TableRow key="importe-diurno">
                <TableCell className={css.tdtitle} align="left"><Brightness4Icon fontSize="small"></Brightness4Icon> <span>Importe Diurno</span> </TableCell>
                <TableCell align="right">${props.price.Importe}</TableCell>
              </TableRow>
              <TableRow key="importe-diruno-max">
                <TableCell className={css.tdtitle} align="left"><Brightness4Icon fontSize="small"></Brightness4Icon> <span>Importe Diurno Max.</span></TableCell>
                <TableCell align="right">${props.price.ImporteMax}</TableCell>
              </TableRow>
              <TableRow key="importe-nocturno">
                <TableCell className={css.tdtitle} align="left"><NightsStayIcon fontSize="small"></NightsStayIcon> <span>Nocturo</span></TableCell>
                <TableCell align="right">${props.price.ImporteNocturno}</TableCell>
              </TableRow>
              <TableRow key="importe-nocturno-max">
                <TableCell className={css.tdtitle} align="left"><NightsStayIcon fontSize="small"></NightsStayIcon> <span>Nocturo Max.</span></TableCell>
                <TableCell align="right">${props.price.ImporteMaxNocturno}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}
